import artNouveauTemplateJson from "./palettes/art-nouveau.json";
import baroqueTemplateJson from "./palettes/baroque.json";
import bauhausTemplateJson from "./palettes/bauhaus.json";
import cottagecoreTemplateJson from "./palettes/cottagecore.json";
import cyberpunkTemplateJson from "./palettes/cyberpunk.json";
import darkAcademiaTemplateJson from "./palettes/dark-academia.json";
import gothicTemplateJson from "./palettes/gothic.json";
import modernTemplateJson from "./palettes/modern.json";
import scandinavianTemplateJson from "./palettes/scandinavian.json";
import wabiSabiTemplateJson from "./palettes/wabi-sabi.json";
import type { PaletteTemplate } from "./types.js";
import { loadPaletteImage } from "./imageCache.js";

const paletteBoardTemplates: Record<string, PaletteTemplate> = {
  "art-nouveau": artNouveauTemplateJson as PaletteTemplate,
  baroque: baroqueTemplateJson as PaletteTemplate,
  bauhaus: bauhausTemplateJson as PaletteTemplate,
  cottagecore: cottagecoreTemplateJson as PaletteTemplate,
  cyberpunk: cyberpunkTemplateJson as PaletteTemplate,
  "dark-academia": darkAcademiaTemplateJson as PaletteTemplate,
  default: modernTemplateJson as PaletteTemplate,
  gothic: gothicTemplateJson as PaletteTemplate,
  scandinavian: scandinavianTemplateJson as PaletteTemplate,
  "wabi-sabi": wabiSabiTemplateJson as PaletteTemplate,
};

const fallbackTemplate = paletteBoardTemplates["art-nouveau"]!;

export function paletteBoardTemplateForPreset(preset: string): PaletteTemplate {
  return paletteBoardTemplates[preset] ?? fallbackTemplate;
}

export function preloadPaletteBoardForPreset(preset: string): void {
  const template = paletteBoardTemplates[preset];
  if (template) void loadPaletteImage(template.imageUrl).catch(() => undefined);
}
